module.exports = __webpack_public_path__ + "img/box1_bg.14b6c897.png";